import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/cargos"

export default {

    get(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },

    create(data) {
        return apiCall('post', `${PREFIX}`, data)
    },

    update(cargoID, data) {
        return apiCall('post', `${PREFIX}/${cargoID}/update`, data)
    },

    delete(cargoID) {
        return apiCall('delete', `${PREFIX}/${cargoID}`)
    }
}